import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TicketList from './pages/TicketList';
import CreateTicket from './pages/CreateTicket';
import TicketDetail from './pages/TicketDetail';
import Reports from './pages/Reports';
import KRAReport from './pages/KRAReport';
import MonthlyReport from './pages/MonthlyReport';
import CustomerAnalytics from './pages/CustomerAnalytics';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Tenants from './pages/Tenants';
import Network from './pages/Network';

import Profile from './pages/Profile';
import TechWorkReport from './pages/TechWorkReport';
import MonitorReport from './pages/MonitorReport';
import LCODashboard from './pages/LCODashboard';
import LCOExpenses from './pages/LCOExpenses';
import LCOFeatures from './pages/LCOFeatures';
import LCOPaymentSetup from './pages/LCOPaymentSetup';
import TicketCategoryReport from './pages/TicketCategoryReport';
import TicketSearch from './pages/TicketSearch';
import LCOFeedbackReport from './pages/LCOFeedbackReport';
import TargetTracker from './pages/TargetTracker';
import CrmLog from './pages/CrmLog';
import SupportCalls from './pages/SupportCalls';
import WeeklyReports from './pages/WeeklyReports';
import PublicComplaint from './pages/PublicComplaint';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><p>Loading...</p></div>;
  return user ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/complaint/:tenant_code" element={<PublicComplaint />} />
          <Route path="/weekly-reports" element={<PrivateRoute><WeeklyReports /></PrivateRoute>} />
          <Route path="/crm" element={<PrivateRoute><CrmLog /></PrivateRoute>} />
          <Route path="/support-calls" element={<PrivateRoute><SupportCalls /></PrivateRoute>} />
          <Route path="/lco" element={<PrivateRoute><LCODashboard /></PrivateRoute>} />
          <Route path="/lco/expenses" element={<PrivateRoute><LCOExpenses /></PrivateRoute>} />
          <Route path="/lco-features" element={<PrivateRoute><LCOFeatures /></PrivateRoute>} />
          <Route path="/lco/payment-setup" element={<PrivateRoute><LCOPaymentSetup /></PrivateRoute>} />
          <Route path="/ticket-report" element={<PrivateRoute><TicketCategoryReport /></PrivateRoute>} />
          <Route path="/ticket-search" element={<PrivateRoute><TicketSearch /></PrivateRoute>} />
          <Route path="/lco-feedback-report" element={<PrivateRoute><LCOFeedbackReport /></PrivateRoute>} />
          <Route path="/target-tracker" element={<PrivateRoute><TargetTracker /></PrivateRoute>} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/tickets" element={<PrivateRoute><TicketList /></PrivateRoute>} />
          <Route path="/tickets/new" element={<PrivateRoute><CreateTicket /></PrivateRoute>} />
          <Route path="/tickets/:id" element={<PrivateRoute><TicketDetail /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
          <Route path="/kra" element={<PrivateRoute><KRAReport /></PrivateRoute>} />
          <Route path="/monthly-report" element={<PrivateRoute><MonthlyReport /></PrivateRoute>} />
          <Route path="/customer-analytics" element={<PrivateRoute><CustomerAnalytics /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute><Analytics /></PrivateRoute>} />
          <Route path="/tenants" element={<PrivateRoute><Tenants /></PrivateRoute>} />
          <Route path="/network" element={<PrivateRoute><Network /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/tech-reports" element={<PrivateRoute><TechWorkReport /></PrivateRoute>} />
          <Route path="/monitor-reports" element={<PrivateRoute><MonitorReport /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
